import React, { Component } from 'react'
import { Route, Switch } from "react-router-dom"

import Home from 'components/static/Home'
import AppIndex from './AppIndex'

class UnloginedStaticPages extends Component {
	render() {
		return (
			<Switch>
				<Route exact path="/app_index" component={AppIndex}/>
				<Route exact path="/" component={Home}/>
			</Switch>
		)
	}
}

export default UnloginedStaticPages
